<template>
  <a
    href="#"
    @click.stop.prevent="onSlideTop()"
    id="slide_top"
    class="seasidetms_theme_icon_slide_top"
  >
    <span></span>
  </a>
</template>

<script>
export default {
  name: 'ButtonSlideTop',
  methods: {
    onSlideTop() {
      alert('todo')
    },
  },
}
</script>

<style></style>
